

import Select from './select'


const SHOW_STANDARD_COUNT = 10;
const SHOW_PREVIEW_COUNT = 1;


const sortRecords = function(records) {
    records.sort((a, b) => {
        // version
        let versionA = parseInt(a.version),
            versionB = parseInt(b.version);

        versionA = versionA < 2000 ? versionA * 10000 : versionA;
        versionB = versionB < 2000 ? versionB * 10000 : versionB;

        if (versionA < versionB) { return 1; }
        if (versionA > versionB) { return -1; }

        // localization
        let highlight = ['INT'],
            localizationA = a.localization.toUpperCase(),
            localizationB = b.localization.toUpperCase();

        if (localizationA < localizationB) { return -1; }
        if (localizationA > localizationB) { return 1; }

        // build
        let buildA = parseInt(a.build),
            buildB = parseInt(b.build);

        if (buildA < buildB) { return 1; }
        if (buildA > buildB) { return -1; }

        return 0;
    });

    return records;
}



/**
 * Archicad Updates
 */
class Updates {
    constructor(node) {
        console.log('Updates constructor(node)', node);

        this.node = node;
        this.results = node.querySelector('[data-results]');
        this.header = node.querySelector('table > thead');
        this.noresults = node.querySelector('[data-noresults]');
        this.showMore = node.querySelector('[data-showmore]');

        this.db = [];
        this.filters = {};

        let form = node.querySelector('form');

        // this.template = this.results.innerHTML;
        // this.results.innerHTML = '';

        // HACK
        this.showMore.addEventListener('click', event => {
            event.preventDefault();

            let hiddenRecords = [...this.results.querySelectorAll('.hidden')];
            hiddenRecords.forEach(item => {
                item.classList.remove('hidden');
            });

            this.showMore.classList.add('hidden');
        }, false);
        // /HACK


        form.addEventListener('change', this, false);

        // this.init();
        this.ready = this.loadDb().then((records) => {
            this.db = sortRecords(records);

            [...form.querySelectorAll('select')].forEach(filterNode => {
                let filter = new Select(filterNode, this.db);
                this.filters[filter.getName()] = filter;
            });
    
            // Trigger change on filters to get initial state
            Object.values(this.filters).forEach(filter => {
                filter.triggerChange();
            });
    
            this.render();
        });
    }

    handleEvent(event) {
        console.info('Updates.handleEvent() [event]', event);

        switch (event.type) {
            case 'change':
                this.render();
        }
    }

    loadDb() {
        console.log('Updates.loadDb()');

        let source = this.node.dataset.source;
        
        return new Promise((resolve, reject) => {
            console.log('Updates.loadDb() [source]', source);

            let xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = () => {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    console.log('Updates.loadDb() [xhttp.responseText]', xhttp.responseText);
                    resolve(JSON.parse(xhttp.responseText));
                }
            };
            xhttp.open('GET', source, true);
            xhttp.send();
        });
    }

    getResultSet() {
        let filter = {};
        for (const [key, select] of Object.entries(this.filters)) {
            filter[key] = select.getValue();
        }

        console.info('Updates.getResultSet() [filter]', filter);

        let resultLimiter = {
            standard: { current: 0, max: filter['localization'] ? 1 : SHOW_STANDARD_COUNT },
            preview: { current: 0, max: SHOW_PREVIEW_COUNT },
        };
        let build = 0;
        let results = this.db.filter((record) => {
            let pass = true;
            record.hide = false;

            for (const [key, value] of Object.entries(filter)) {
                if (value && record[key] !== value) {
                    pass = false;
                }
            }

            if (pass) {
                let counterKey = record.preview ? 'preview' : 'standard';

                if (++resultLimiter[counterKey].current > resultLimiter[counterKey].max) {
                    // pass = false;
                    record.hide = true;
                }

                if (record.preview && record.build < build) {
                    // pass = false;
                    record.hide = true;
                }

                if (!record.hide) {
                    build = record.build;
                }
            }

            console.info('Updates.getResultSet() [resultLimiter, pass]', resultLimiter, pass);

            return pass;
        });

        return results;
    }

    render() {
        let results = this.getResultSet(),
            resultHtml = '';

        console.info('Updates.render() [results]', results);

        // this.header.classList[!results.length ? 'add' : 'remove']('hidden');
        this.noresults.classList[!!results.length ? 'add' : 'remove']('hidden');

        const names = {
                'FULL'  : `Archicad&nbsp;|VERSION|&nbsp;Full`,
                'START' : `Archicad&nbsp;Start&nbsp;Edition&nbsp;|VERSION|`,
                'SOLO'  : `Archicad&nbsp;|VERSION|&nbsp;Solo`,
                'BTC'   : `BIMcloud&#160;Team&#160;Client&nbsp;|VERSION|`,
            },
            template = global.tmpl('tmpl-update');

        let hasHidden = false;// HACK
        for (let i = 0; i < results.length; i++) {
            const record = results[i];
            record.name = names[record.type] ? names[record.type].replace('|VERSION|', record.version) : record.type;

            if (record.hide) {
                hasHidden = true;// HACK
            }
            resultHtml += template(record);
        }

        this.results.innerHTML = resultHtml;

        // this.showMore.style.display = hasHidden ? 'block' : 'none';// HACK
        this.showMore.classList[hasHidden ? 'remove' : 'add']('hidden');
    }

    setFilter(key, value) {
        console.info('Updates.setFilter() [key, value]', key, value);

        let input = this.filters[key];
        if (input) {
            input.setValue(value);
        }
    }

    static init(selector) {
        console.info('Updates::init(selector) [selector]', selector);

        let instances = [],
            nodes = [...document.querySelectorAll(selector)];

        nodes.forEach(node => {
            instances.push(new Updates(node));
        });

        return instances;
    }
}


export default Updates;

